<template>
    <div class="newsletter-form" v-if="is_show">
        <Close @click.native="is_show = false" />
        <div class="box">
            <iframe :src="url" />
            <!-- <h2>Newsletter</h2>
            <p>Sign up for updates about exhibitions, events and news.</p> -->

            <!-- <div id='pb_signup_container'></div>
            <script language="javascript">
            $(function() {
            $('#pb_signup_container').load("https://uk.patronbase.com/_Charleston/Signup/Form?layout=none");
            });
            </script> -->
                    <!-- <form id="email_signup" class="klaviyo_styling klaviyo_gdpr_embed_XSGM25" action="//manage.kmail-lists.com/subscriptions/subscribe" data-ajax-submit="//manage.kmail-lists.com/ajax/subscriptions/subscribe" method="GET" target="_blank" novalidate="novalidate">
                        <input type="hidden" name="g" value="XSGM25">
                        <div class="klaviyo_field_group">
                            <input class="" type="email" value="" name="email" id="k_id_email" placeholder="Email" required/>
                            <input type="text" name="first_name" id="k_id_first_name" placeholder="Name"/>
                            <input type="text" name="last_name" id="k_id_last_name" placeholder="Surname"/>
                        </div>
                        <div class="klaviyo_messages">
                            <div class="success_message" style="display:none;"></div>
                            <div class="error_message" style="display:none;"></div>
                        </div>
                        <div class="submit"><button type="submit">Send</button> </div>
                        
                    </form> -->
    

                
        </div>
        <!-- <div class="is-ok" v-else>
            <div>
                <h2>Thank you for<br>
                signing up to our<br>
                e-newsletter</h2>
            </div>
        </div> -->
    </div>
</template>

<script>
// import Pool from '@/utils/Pool';
import { EventBus } from '@/events/bus.js';
import Close from '@/components/ui/Close.vue';

export default {
    name: 'newsletter-form',

    data() {
        return {
            is_show: false,
            url: '',
        }
    },
    components: {
        Close,
    },

    // methods: {
    //     newsletter () {
    //         console.log('newsletter')
    //         KlaviyoSubscribe.attachToForms('#email_signup', {
    //             hide_form_on_success: true,
    //             extra_properties: {
    //                 $source: '$embed',
    //                 $method_type: "Charleston Form",
    //                 $method_id: 'embed',
    //                 $consent_version: 'Embed default text'
    //             }
    //         });
    //     },
    // },

    mounted() {
        this.url = window.globals.home_url + '/newsletter/';
        EventBus.$off('newsletter.close');

        EventBus.$on('newsletter.open', () => {
            this.is_show = true;

            // if (typeof KlaviyoSubscribe === 'undefined') {
            //     const plugin = document.createElement("script");
            //     plugin.setAttribute(
            //     "src",
            //     "//www.klaviyo.com/media/js/public/klaviyo_subscribe.js"
            //     );
            //     plugin.async = true;
            //     document.head.appendChild(plugin);
            // }

            // Pool(
            //     () => {
            //         return (typeof KlaviyoSubscribe !== 'undefined')
            //     },
            //     () => {
            //         this.newsletter();
            //     }
            // )
        });

        
    },
}
</script>
<style lang="scss">
    .newsletter-form {
        position: fixed;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        background: var(--green);
        z-index: 99999999999999999999;
        color: white;

        iframe{
            overflow: auto;
            height: 100%;
            width: 100%;
            position: absolute;
            left: 0;
            top: 0;
        }






    }
</style>